<template>
  <div class="lbv-leak-list animated fadeIn roundedCard">
    <div class="row">
      <div class="col-lg-12">
        <b-card>
          <div class="col-lg-12 leak-list-header">
            <span class="lbv-page-title">Incomplete Installs</span>
          </div>
          <div class="row secondary lbv-search">
            <form
              class="lbv-search-filter w-100 mx-3"
              @submit.prevent="search"
            >
              <b-row class="w-100 d-flex align-items-center">
                <b-col>
                  <b-form-group
                    label="Search Type"
                    label-for="search-type"
                  >
                    <b-input-group>
                      <b-form-select
                        id="search-type"
                        v-model="typeSearch"
                        :options="searchType"
                        @input="fetchIncompleteInstallsListData" 
                        @change.native="onChange"
                      />
                    </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col>
                  <b-form-group
                    label="Search"
                    label-for="search"
                  >
                    <b-input-group>
                      <input
                        id="search"
                        v-model="searchInput"
                        type="text"
                        class="form-control full-width"
                        placeholder=""
                      >
                    </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col>
                  <b-form-group
                    label="Rows"
                    label-for="rows"
                  >
                    <b-input-group>
                      <b-form-select
                        id="rows"
                        v-model="perPage"
                        :options="pageOptions"
                      />
                    </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col
                  cols="4"
                  class="d-flex align-items-center"
                >
                  <b-button
                    id="applyBtn"
                    variant="primary"
                    class="w-100 mr-3"
                    type="submit"
                  >
                    Apply
                  </b-button>
                  <b-button
                    id="applyBtn"
                    variant="primary"
                    class="w-100"
                    @click.prevent="downloadReport"
                  >
                    <span class="download">Export CSV File</span>
                  </b-button>
                </b-col>
              </b-row>
            </form>
          </div>

          <b-modal
            id="mark-as-disabled"
            ref="markAsDisabledUserDetails"
            title="Incomplete Install - Mark As Disabled" 
            ok-variant="primary"
            ok-title="Ok"
            @ok="markAsDisabled"
          >
            <div class="col-md-12">
              <h6 class="text-center">
                Are you sure you want to change the User details to <b>{{ selectedUser.username }}</b>?
              </h6>
            </div>
          </b-modal>

          <b-alert
            :show="errorString != &quot;&quot;"
            variant="danger"
          >
            {{ errorString }}
          </b-alert>
          <b-table
            responsive
            striped
            hover
            :items="incompleteInstallsList"
            :fields="fields"
          >
            <template
              slot="address_1postCode"
              slot-scope="data"
            >
              {{ data.item.address_1 }}, {{ data.item.postCode }}
            </template>
            <template
              slot="action"
              slot-scope="data"
            >
              <b-link
                class="deviceLink"
                @click="showUserDetails(data)"
              >
                Mark as disabled
              </b-link>
            </template>
          </b-table>
          <b-button
            class="page prev"
            variant="primary"
            size="sm"
            :disabled="pageNumber === 1"
            @click.prevent="page"
          >
            Prev
          </b-button>

          <b-button
            class="page next"
            variant="primary"
            size="sm"
            :disabled="!hasNextPage"
            @click.prevent="page"
          >
            Next
          </b-button>
          <div class="current-page">
            Page: {{ pageNumber }}
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import incompleteInstallsMixin from '../mixins/incompleteInstallsMixin'

export default {
  name: 'IncompleteInstalls',
  mixins: [incompleteInstallsMixin]
}
</script>
